import React from "react";

const NoRecipes = () => {
  return (
    <div className="error-card">
      <span>no recipes found</span>
    </div>
  );
};

export default NoRecipes;
